module.exports = __webpack_public_path__ + "img/17-eng.e7ccaf4e.png";